export class FlyoutDemoContext {
  public id: number;
  public name: string;
}
